<forge-card telemetry="Card-NewPacketLaunch-UtilityBilling" no-padding>
  <forge-toolbar fxLayout="column">
    <h2 slot="start" class="forge-typography--heading4">New Packet Launch</h2>
  </forge-toolbar>

  <div fxLayout="column" class="metadata-padding">

    @if (!hasItems) {
      <div fxFlex fxLayoutAlign="center">
        You have no New Packet Templates
      </div>
    }

    @if (hasItems) {
      <!--
      <div *ngFor="let item of displayItems" fxLayout="row" fxLayoutAlign="space-between center" class="row">
        <div fxFlex="20" class="module">{{item.Module}}</div>
        <div fxFlex="25" class="not-module">{{item.Process}}</div>
        <div fxFlex="35" class="not-module">{{item.Description}}</div>
        <button mat-icon-button fxFlex="8" (click)="launch(item)" [disabled]="isSaving" matTooltip="Launch"
          [attr.telemetry]="getLaunchAriaLabel(item)">
          <mat-icon fontIcon="play_arrow" fontSet="material-icons">
          </mat-icon>
        </button>
        <button mat-icon-button fxFlex="8" (click)="newPacketTemplate(item)" [disabled]="isSaving"
          matTooltip="Edit" [attr.telemetry]="getEditAriaLabel(item)">
          <mat-icon fontIcon="mode_edit" fontSet="material-icons">
          </mat-icon>
        </button>
        <button mat-icon-button fxFlex="8" (click)="delete(item)" [disabled]="isSaving" matTooltip="Delete"
          [attr.telemetry]="getDeleteAriaLabel(item)">
          <mat-icon fontIcon="delete" fontSet="material-icons">
          </mat-icon>
        </button>
      </div>
      -->
      <table mat-table [dataSource]="tableData" fxFill>
        <ng-container matColumnDef="module">
          <th mat-header-cell *matHeaderCellDef>Module</th>
          <td mat-cell *matCellDef="let row"> {{row.Module}} </td>
        </ng-container>
        <ng-container matColumnDef="process">
          <th mat-header-cell *matHeaderCellDef>Process</th>
          <td mat-cell *matCellDef="let row">{{row.Process}}</td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>Description</th>
          <td mat-cell *matCellDef="let row">{{row.Description}}</td>
        </ng-container>
        <ng-container matColumnDef="launch">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <forge-icon-button (click)="launch(row)" [disabled]="isSaving" [attr.aria-label]="getLaunchAriaLabel(row)" [attr.telemetry]="getLaunchAriaLabel(row)">
              <forge-tooltip position="bottom">Launch</forge-tooltip>
              <forge-icon name="play_arrow"></forge-icon>
            </forge-icon-button>
          </td>
        </ng-container>
        <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <forge-icon-button (click)="newPacketTemplate(row)" [disabled]="isSaving" [attr.aria-label]="getEditAriaLabel(row)" [attr.telemetry]="getEditAriaLabel(row)">
              <forge-tooltip position="bottom">Edit</forge-tooltip>
              <forge-icon name="edit"></forge-icon>
            </forge-icon-button>
          </td>
        </ng-container>
        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <forge-icon-button (click)="delete(row)" [disabled]="isSaving" [attr.aria-label]="getDeleteAriaLabel(row)" [attr.telemetry]="getDeleteAriaLabel(row)">
              <forge-tooltip position="bottom">Delete</forge-tooltip>
              <forge-icon name="delete"></forge-icon>
            </forge-icon-button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
        <tr mat-row *matRowDef="let myRowData; columns: columnNames"></tr>
      </table>
      @if (canShowMore) {
        <div>
          <forge-divider></forge-divider>
          <forge-icon-button (click)="showMore($event)">
            <forge-tooltip position="bottom">Show more</forge-tooltip>
            <forge-icon name="more_horiz"></forge-icon>
          </forge-icon-button>
        </div>
      }
    }

    @if(isSaving)
      {
      <forge-linear-progress mode="indeterminate"></forge-linear-progress>
    }

  </div>

  <div fxLayout="row" fxLayoutAlign="end center">
    <forge-icon-button variant="filled" telemetry="Submission-Add-NewTemplate-UtilityBilling"
      (click)="newPacketTemplate()" tabindex="0" aria-label="add new template">
      <forge-tooltip position="bottom">Add new template</forge-tooltip>
      <forge-icon name="add"></forge-icon>
    </forge-icon-button>
  </div>

</forge-card>